export default __webpack_public_path__ + "54a9b499c2c1a48c5c3109980970d005.png";